import { render, staticRenderFns } from "./new-reservation.vue?vue&type=template&id=a40ea56e"
import script from "./new-reservation.vue?vue&type=script&lang=js"
export * from "./new-reservation.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./new-reservation.vue?vue&type=style&index=1&id=a40ea56e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports